// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"615":"292d3d2f","817":"e21cc1f7"}[chunkId] + ".chunk.css";
};